'use client';

import { useState } from 'react';

import { FeatureReviewCatalogBase } from '@/fo/feature/review/catalog/base';
import { FeatureReviewDetailBase } from '@/fo/feature/review/detail/base';
import {
  FeatureReviewFormBase,
  RatingValue
  // UserInfo
} from '@/fo/feature/review/form/base';
import {
  ReviewsData,
  ReviewTab,
  Product,
  Review
} from '@/fo/ui/review/catalog/base';
import { UiReviewDetailBase } from '@/fo/ui/review/detail/base';
import { UiReviewSectionBase } from '@/fo/ui/review/section/base';

export interface ReviewSectionClientProps {
  reviewsData: ReviewsData;
  ratingId: string;
  ratings: RatingValue[];
  // userInfo?: UserInfo;
  product: Product;
  isAuthorized: boolean;
}

export function ReviewSectionClient({
  ratingId,
  ratings,
  // userInfo,
  reviewsData,
  product
}: ReviewSectionClientProps) {
  const [openForm, setOpenForm] = useState<ReviewTab>();
  const [catalogOpen, setCatalogOpen] = useState<ReviewTab | null>();
  const [reviewId, setReviewId] = useState<string | null>(null);
  const [fullReview, setFullReview] = useState<Review | null>(null);

  const handleOpenForm = (type: ReviewTab) => {
    setOpenForm(type);
  };

  const handleOpenChange = (open: boolean) => {
    setOpenForm(open ? openForm : undefined);
  };

  const handleCloseCatalog = () => {
    setCatalogOpen(null);
  };

  const handleOpenCatalog = (open: boolean) => {
    setCatalogOpen(open ? catalogOpen : null);
  };

  return (
    <>
      <UiReviewSectionBase
        id="review"
        reviewsData={reviewsData}
        onActionButtonClick={handleOpenForm}
        onViewAllClick={(tab) => {
          setCatalogOpen(tab);
        }}
        onReviewClick={setFullReview}
      />
      <UiReviewDetailBase
        open={!!fullReview}
        onOpenChange={(open) => {
          if (!open) {
            setFullReview(null);
          }
        }}
        review={fullReview ?? undefined}
      />
      <FeatureReviewDetailBase
        reviewId={reviewId}
        onClose={() => setReviewId(null)}
      />
      <FeatureReviewCatalogBase
        reviewsData={reviewsData}
        product={product}
        open={catalogOpen}
        onOpenChange={handleOpenCatalog}
        onClose={handleCloseCatalog}
        onActionClick={handleOpenForm}
      />
      <FeatureReviewFormBase
        open={!!openForm}
        onOpenChange={handleOpenChange}
        product={product}
        type="review"
        ratingId={ratingId}
        ratings={ratings}
        // userInfo={userInfo}
      />
    </>
  );
}
